import { IntegrationEnum } from 'models/InternalIntegrationSetting';
import { Navigate } from 'react-router-dom';
import useFetchIntegrationAgencySettings from 'hooks/useFetchIntegrationAgencySettings';
import useFeatures from 'hooks/useFeatures';
import Loader from 'components/loader/Loader';
import Breadcrumbs from '../components/breadcrumbs/Breadcrumbs';
import useShouldRedirectToIntegrationsList from './hooks/useShouldRedirectToIntegrationsList';
import { ZapierTemplatesWrapper } from './ZapierTemplates.styles';
import AuthInformation from './components/AuthInformation';
import ZapierWidget from './components/ZapierWidget';

const ZapierTemplates = () => {
  const { allowIntegrationsV3 } = useFeatures();

  const { data: integrationAgencySettings, isLoading } =
    useFetchIntegrationAgencySettings({
      enumId: IntegrationEnum.ZAPIER,
    });

  const integrationName =
    integrationAgencySettings?.integration?.displayName ??
    integrationAgencySettings?.integration?.name;

  const shouldRedirectToIntegrationsList =
    useShouldRedirectToIntegrationsList();

  if (!allowIntegrationsV3) {
    return <Navigate to="/integrations-migrated" />;
  }

  if (shouldRedirectToIntegrationsList) {
    return <Navigate to="/integrations" />;
  }

  if (isLoading) {
    return <Loader />;
  }

  if (!integrationAgencySettings) {
    return null;
  }

  return (
    <ZapierTemplatesWrapper>
      <Breadcrumbs
        name={integrationName ?? ''}
        logo={integrationAgencySettings?.integration?.logo ?? ''}
      />

      <AuthInformation
        agencySettings={integrationAgencySettings.agencySettings}
      />

      <ZapierWidget />
    </ZapierTemplatesWrapper>
  );
};

export default ZapierTemplates;
